<template>
  <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/write">Write</router-link> |
    <router-link to="/label">Label</router-link> |
    <router-link to="/upload">Upload</router-link> |
    <router-link to="/download">Download</router-link> |
    <router-link to="/verify">Verify</router-link>
  </nav>
  <router-view />
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
  width: 100%;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

:root {
  --button: #7289da;
  --highlight-details: #424549;
  --highlight: #36393e;
  --background: #1e2124;
  --background-light: #282b30;
  --text: white;
}

html,
body {
  height: 100%;
  width: 100%;
}

body {
  margin: 0;
  background: var(--background);
}

button {
  border: none;
  border-radius: 2mm;
  padding: 3mm;
  background-color: var(--button);
  font-size: 6mm;
  font-weight: 400;
  min-width: 4cm;
}

nav {
  padding: 30px;
  max-height: fit-content;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

span {
  border: 1mm solid;
  border-radius: 5mm;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5mm;
  padding: 5mm;
  background: var(--background-light);
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background-color: grey;
  gap: 5mm;
}
</style>
